import { render, staticRenderFns } from "./DeviceCard.vue?vue&type=template&id=89553ca6&scoped=true"
import script from "./DeviceCard.vue?vue&type=script&lang=js"
export * from "./DeviceCard.vue?vue&type=script&lang=js"
import style0 from "./DeviceCard.vue?vue&type=style&index=0&id=89553ca6&prod&lang=css"
import style1 from "./DeviceCard.vue?vue&type=style&index=1&id=89553ca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89553ca6",
  null
  
)

/* custom blocks */
import block0 from "./DeviceCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports